"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Rule_1 = require("./_Rule");
exports._Rules = {
    type: "list",
    flattened: true,
    member: {
        shape: _Rule_1._Rule
    }
};
//# sourceMappingURL=_Rules.js.map